<template>
    <span>
        <eventoslistagem></eventoslistagem>
    </span>
</template>

<script>
import Eventoslistagem from '@/components/Eventos-Listagem';

export default {
    name: 'cadeventoslistagem',
    components: {
        Eventoslistagem
    }
};
</script>